import mainImg from "../../../assets/fonging-glass-shutter(680mmx600mm).webp";
import thumb1 from "../../../assets/fonging-glass-shutter(680mmx600mm).webp";
import thumb2 from "../../../assets/fonging-glass-shutter(680mmx600mm).webp";
import mainImg3 from "../../../assets/folding-glass-shutter.webp";
import thumb7 from "../../../assets/folding-glass-shutter.webp";
import thumb8 from "../../../assets/folding-glass-shutter.webp";

import mainImg1 from "../../../assets/pvc-rolling-shutter.webp";
import thumb3 from "../../../assets/pvc-rolling-shutter.webp";
import thumb4 from "../../../assets/pvc-rolling-shutter.webp";


import mainImg2 from "../../../assets/pvc-rolling-shutter.webp";
import thumb5 from "../../../assets/pvc-rolling-shutter.webp";
import thumb6 from "../../../assets/pvc-rolling-shutter.webp";

export  const pullOutProducts = [
  {
  code: "PO-01",
  name: "GLASS ROLLING SHUTTER 600MM",
  category: "rolling shutter",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  short:
    "The Glass Rolling Shutter 600mm is a premium kitchen storage solution that combines elegance and functionality. Designed with tempered glass panels and high-quality aluminum tracks, it ensures smooth, quiet operation while providing easy access to kitchen essentials. Its sleek modern design fits seamlessly into contemporary kitchens, maximizing space and enhancing aesthetics. Ideal for storing utensils, pantry items, or decorative pieces, it adds a touch of sophistication while maintaining practicality and durability.",

  features: [
    "Smooth 360° rolling mechanism for easy access",
    "Tempered glass panels for durability and safety",
    "Space-saving design ideal for compact kitchens",
    "Corrosion-resistant aluminum frame",
    "Soft-close mechanism prevents slamming"
  ],

  /* ✅ PRICE */
  price: "₹21390",
  oldPrice: "₹25000",

  /* ✅ SKU + STOCK */
  sku: "7085 - 7236",
  stock: "In Stock",

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91?text=Glass%20Rolling%20Shutter%20600MM%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Tempered Glass + Aluminum Frame" },
    { label: "Size", value: "600MM" },
    { label: "Type", value: "Glass Rolling Shutter" },
    { label: "Mechanism", value: "Smooth Rolling System" },
    { label: "Application", value: "Kitchen Cabinet / Storage Unit" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "Glass Rolling Shutter",
      code: "7085 , 7430 , 7236",
      size: "Black / Frost / White ",
      finish: "Glass"
    },
    
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "Is the glass tempered and safe for kitchen use?",
      answer:
        "Yes, it uses high-quality tempered glass which is strong, safe, and durable for kitchen environments."
    },
    {
      question: "Can it be installed in compact kitchen spaces?",
      answer:
        "Yes, the 600mm design makes it perfect for small and medium kitchen layouts."
    },
    {
      question: "Does it have a soft-close mechanism?",
      answer:
        "Yes, it features a smooth soft-close system to ensure silent and safe operation."
    },
    {
      question: "What materials are used in its construction?",
      answer:
        "It is made from a corrosion-resistant aluminum frame with tempered glass panels."
    },
    {
      question: "Can it hold kitchen items safely?",
      answer:
        "Yes, it can safely store utensils, jars, and light kitchen essentials."
    }
  ]
},


   {
  code: "PO-04",
  name: "FOLDING GLASS SHUTTER",
  category: "rolling shutter",

  mainImage: mainImg3,
  thumbnails: [thumb7, thumb8],

  short:
    "The Folding Glass Shutter is a stylish and functional solution for modern interiors. Made from high-quality tempered glass and durable hardware, it allows smooth folding action, saving space while providing an elegant look. Ideal for kitchens, wardrobes, display cabinets, or office partitions, it combines transparency with security and easy operation. Its sleek design complements contemporary decor and ensures low maintenance.",

  features: [
    "Made from high-quality tempered glass for safety and durability.",
    "Smooth folding mechanism for space-saving operation.",
    "Perfect for kitchens, wardrobes, display cabinets, or partitions.",
    "Low maintenance; easy to clean with glass-friendly cleaners.",
    "Elegant and modern design enhances interior aesthetics.",
    "Provides visibility while keeping contents secure."
  ],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ PRICE */
  price: "₹23800",
  oldPrice: "₹24000",

  sku: "7610",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91?text=Folding%20Glass%20Shutter%20Inquiry",

  specifications: [
    { label: "Material", value: "Tempered Glass + Hardware" },
    { label: "Type", value: "Folding Glass Shutter" },
    { label: "Application", value: "Kitchen / Wardrobe / Cabinet / Partition" }
  ],
  /* ✅ SPEC TABLE */
specTable: [
  {
    item: "FOLDING GLASS SHUTTER",
    code: "7610",
    size: "Black",
    finish: "Glass"
  },
  
],

  faq: [
    {
      question: "Is the Folding Glass Shutter safe for home use?",
      answer:
        "Yes, it is made from tempered glass, which is strong, durable, and safe for daily use."
    },
    {
      question: "Where can Folding Glass Shutters be installed?",
      answer:
        "They are ideal for kitchen cabinets, wardrobes, display units, and office partitions."
    },
    {
      question: "How do I maintain the shutter?",
      answer:
        "Clean with a soft cloth and glass cleaner for best results."
    },
    {
      question: "Does the shutter save space?",
      answer:
        "Yes, the folding mechanism helps save space in compact areas."
    },
    {
      question: "Can size be customized?",
      answer:
        "Yes, it can be customized as per requirement."
    }
  ]
},

{
  code: "PO-02",
  name: "PVC ROLLING SHUTTER 600MM",
  category: "rolling shutter",

  mainImage: mainImg1,
  thumbnails: [thumb3, thumb4],

  short:
    "The PVC Rolling Shutter 600mm is a durable, lightweight, and corrosion-resistant shutter designed for both residential and commercial applications. Its smooth rolling mechanism allows easy operation, making it ideal for kitchens, shops, storage areas, and garages. The PVC construction ensures longevity, low maintenance, and resistance against moisture, rust, and pests. Its compact design fits perfectly in modular spaces while providing secure and stylish closure.",

  features: [
    "Made from high-quality PVC for durability and moisture resistance.",
    "Smooth rolling mechanism for effortless operation.",
    "Low maintenance and easy to clean.",
    "Resistant to rust, corrosion, and termite attacks.",
    "Stylish design complements modern interiors.",
    "Suitable for kitchen cabinets, storage units, and commercial spaces."
  ],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ PRICE (optional - add later if available) */
  price: "₹12170",
  oldPrice: "₹13180",

  sku: "7231",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91?text=PVC%20Rolling%20Shutter%20600MM%20Inquiry",

  specifications: [
    { label: "Material", value: "PVC" },
    { label: "Type", value: "Rolling Shutter" },
    { label: "Size", value: "600MM" },
    { label: "Application", value: "Kitchen / Shop / Storage / Garage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "PVC Rolling Shutter",
      code: "7231",
      size: "600MM",
      finish: "PVC White"
    },
    {
      item: "PVC Rolling Shutter",
      code: "7432",
      size: "600MM",
      finish: "PVC White"
    },
    {
      item: "PVC Rolling Shutter",
      code: "7606",
      size: "600MM",
      finish: "PVC White"
    },
    {
      item: "PVC Rolling Shutter",
      code: "7607",
      size: "600MM",
      finish: "PVC White"
    },
    {
      item: "PVC Rolling Shutter",
      code: "7231",
      size: "600MM",
      finish: "PVC White"
    },
  ],

  faq: [
    {
      question: "Is the PVC shutter suitable for kitchen use?",
      answer:
        "Yes, the PVC material is moisture-resistant and safe for kitchen environments."
    },
    {
      question: "Can this shutter be installed in a commercial space?",
      answer:
        "Yes, it is suitable for small shops, storage units, and service counters."
    },
    {
      question: "How is the shutter maintained?",
      answer:
        "It can be easily cleaned with a damp cloth and requires very low maintenance."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality PVC which is resistant to rust, corrosion, and termites."
    },
    {
      question: "Does it come in other sizes?",
      answer:
        "Yes, PVC rolling shutters are available in multiple sizes as per requirement."
    }
  ]
},
{
    code: "PO-03",
    name: "PVC ROLLING SHUTTER 450MM",
    category: "rolling shutter",

    mainImage: mainImg2,

    thumbnails: [thumb5, thumb6],

    short:
      "The PVC Rolling Shutter 450mm is a compact and durable shutter ideal for kitchens, cabinets, and small storage units. Made from high-quality PVC, it offers smooth rolling action, resistance to moisture, corrosion, and pests, while requiring minimal maintenance. Its sleek design fits neatly in tight spaces, providing secure and stylish closure for modular applications.",

    features: [
      "Smooth rolling mechanism for effortless operation.",
      "Compact 450mm width, perfect for small cabinets or openings.",
      "Low maintenance and easy to clean.",
      "Resistant to rust, corrosion, and termite attacks.",
      "Modern design complements kitchen and storage interiors.",
      "Ideal for both residential and commercial modular storage spaces."
    ],
     /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ PRICE (optional - add later if available) */
  price: "₹12170",
  oldPrice: "₹13180",

  sku: "7608-7609",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/91?text=PVC%20Rolling%20Shutter%20600MM%20Inquiry",

/* ✅ SPEC TABLE */
  specTable: [
    {
      item: "PVC Rolling Shutter",
      code: "7608",
      size: "Black",
      finish: "PVC White"
    },
    {
      item: "PVC Rolling Shutter",
      code: "7609",
      size: "Silver",
      finish: "PVC White"
    },
    
  ],

    faq: [
  {
    question: "Is the PVC Rolling Shutter 450mm suitable for kitchens?",
    answer: "Yes, its PVC construction is moisture-resistant, making it ideal for kitchen cabinets and storage areas."
  },
  {
    question: "Can it be used in commercial spaces?",
    answer: "Absolutely. The 450mm shutter works well for small shops, counters, or storage units."
  },
  {
    question: "How do I maintain the shutter?",
    answer: "Simply wipe with a damp cloth. PVC is easy to clean and does not rust or corrode."
  },
  {
    question: "Does the shutter come in other sizes?",
    answer: "Yes, PVC rolling shutters are available in multiple widths and lengths, including 600mm and custom sizes."
  },
  {
    question: "Is installation included?",
    answer: "Installation is generally separate. Proper mounting accessories should be used for safe and secure fitting."
  }
],
  },


];
